"use client"

import NextImageMainPhoto from './NextImageMainPhoto'
import CloudflareMainPhoto from './CloudflareMainPhoto'

function MainPhoto(props) {
	const hasCloudflarePhotos = resolveIfCf(props.offer)
	return hasCloudflarePhotos ? (
		<CloudflareMainPhoto {...props} scrollToChild={scrollToChild} />
	) : (
		<NextImageMainPhoto {...props} scrollToChild={scrollToChild} />
	)
}

function resolveIfCf(offer) {
	const { tracking } = offer || {}
	const { cloudflare } = tracking || {}
	const { mainPhoto, photos } = cloudflare || {}
	return Boolean(photos?.length || mainPhoto)
}

function scrollToChild(parent, child) {
	if (!parent || !child) return
	parent.scrollLeft =
		child.offsetLeft - (parent.clientWidth - child.offsetWidth) / 2
}

export default MainPhoto
